import { createSelector } from "reselect";

const supplierJobsStateSelector = (state) => state.supplierJobs;
const selectById = (state, itemId) => itemId;

export const supplierJobsSelector = createSelector(
  [supplierJobsStateSelector],
  (supplierJobs) => supplierJobs.items
);

export const supplierJobsPendingSelector = createSelector(
  [supplierJobsStateSelector],
  (supplierJobs) => supplierJobs.pennding
);

export const supplierJobsAsLabelAndValueSelector = createSelector(
  [supplierJobsSelector],
  (jobs) =>
    jobs.map(({ _id, name }) => ({
       _id,
     name,
    }))
);

export const supplierJobByIdSelector = createSelector(
  [supplierJobsSelector, selectById],
  (supplierJobs, _id) => {
    const job = supplierJobs.find((item) => _id === item._id);
    if (!job) return null;
    return job;
  }
);

/**
 * Misc
 */

export const supplierJobsIsLoadingSelector = createSelector(
  [supplierJobsStateSelector],
  (supplierJobs) => supplierJobs.isLoading
);

export const supplierJobsCountSelector = createSelector(
  [supplierJobsStateSelector],
  (supplierJobs) => supplierJobs.count
);

export const searchValueSelector = createSelector(
  [supplierJobsStateSelector] , 
  supplierJobs => supplierJobs.searchValue
)